import React from "react";
import { TextField, Paper, IconButton, MenuItem, Typography } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { Controller } from "react-hook-form";
import RichTextEditor from "../../components/RichTextEditor";

const QuestionItem = ({
  index,
  register,
  control,
  remove,
  categories,
  errors,
}) => {
  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      {/* Question */}
      <TextField
        fullWidth
        label="Question"
        {...register(`questions.${index}.questionText`, {
          required: "Question is required",
        })}
        error={!!errors?.questions?.[index]?.questionText}
        helperText={errors?.questions?.[index]?.questionText?.message}
        sx={{ mt: 1 }}
      />

      {/* Answer (Rich Text Editor) */}
      <Controller
        name={`questions.${index}.answerText`}
        control={control}
        rules={{ required: "Answer is required" }}
        render={({ field, fieldState }) => (
          <div style={{ marginTop: "16px" }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              Answer
            </Typography>

            <RichTextEditor
              value={field.value}
              onChange={field.onChange}
            />

            {fieldState.error && (
              <Typography color="error" variant="caption">
                {fieldState.error.message}
              </Typography>
            )}
          </div>
        )}
      />

      {/* Category */}
      <Controller
        name={`questions.${index}.category`}
        control={control}
        rules={{ required: "Category is required" }}
        render={({ field, fieldState }) => (
          <TextField
            select
            fullWidth
            label="Category"
            value={field.value || ""}
            onChange={field.onChange}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            sx={{ mt: 2 }}
          >
            {categories.map((cat) => (
              <MenuItem key={cat.questionId} value={cat.questionName}>
                {cat.questionName}
              </MenuItem>
            ))}
          </TextField>
        )}
      />

      {/* Delete */}
      <IconButton onClick={() => remove(index)} sx={{ mt: 1 }}>
        <Delete color="error" />
      </IconButton>
    </Paper>
  );
};

export default QuestionItem;